import React, { useEffect, useState } from 'react'
import { StepProps } from '../Popup'
import { CartData } from '../../service/cart'
import Loader from '../Loader';
import useGetDataFromSupercontrol from '../hooks/useGetDataFromSupercontrol'

const Step1: React.FunctionComponent<StepProps<CartData, any>> = (props) => {
  const { data, nextStep, setLargePopup, setData } = props
  const [ , setError ] = useState<string>(null)

  const {
    loading,
  } = useGetDataFromSupercontrol(
    data,
    setData,
    setError,
    (msg, data) => {
      setError(msg)
      delete data.voucher

      return data
    },
    () => setError(null)
  )

  useEffect(() => {
    if (data.ref)
      nextStep()
  }, [ data ])

  useEffect(() => {
    setLargePopup(false)
  }, [])

  if (loading)
    return <Loader />

  return <div></div>
}

export default Step1
